import React from 'react';
import { templates } from '../../constants';
import { CustomRadio } from '../../components';
import { SelectedTemplateType } from '@zonofi/zono-money-store';

interface SelectedTemplateProps {
  selectedTemplate: SelectedTemplateType;
  onSelectTemplate: (template: SelectedTemplateType) => void;
}
export const SelectedTemplate: React.FC<SelectedTemplateProps> = ({
  selectedTemplate,
  onSelectTemplate,
}) => {
  return (
    <div className="select-template-screen">
      <div className="select-template-screen-content">
        {templates.map((template) => (
          <div
            className="select-template-screen-content-item"
            key={template?.template}
            onClick={() => onSelectTemplate(template?.template)}
          >
            <div className="select-template-screen-content-item-template">
              <div className="select-template-screen-content-item-template-header">
                <div className="select-template-screen-content-item-template-header-title">
                  <div className="select-template-screen-content-item-template-header-title-text font-semibold">
                    {template?.title}
                  </div>
                  <div className="select-template-screen-content-item-template-header-title-sub-text font-regular">
                    {template?.description}
                  </div>
                </div>
                <div className="select-template-screen-content-item-template-header-select">
                  <CustomRadio
                    checked={
                      selectedTemplate ===
                      (template?.template as SelectedTemplateType)
                    }
                    onSelect={() => onSelectTemplate(template?.template)}
                  />
                </div>
              </div>
              <div
                className={`select-template-screen-content-item-template-image ${
                  template?.fixedSize ? 'fixed-background-size' : ''
                }`}
              >
                <img
                  src={template?.image}
                  alt="template-preview"
                  className={`select-template-screen-content-item-template-image-svg ${
                    template?.fixedSize ? 'fixed-size' : ''
                  }`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
